import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import AdminLayout from '../../components/AdminLayuot';

// --- CONFIGURACIÓN ---
const THEME = {
    primary: '#1F2937',
    secondary: '#3B82F6',
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
    bg: '#F3F4F6',
    white: '#FFFFFF',
    border: '#E5E7EB'
};

const PRODUCTOS = [
    { key: 'CAFE_AMERICANO', label: 'Americano', color: '#78350F' },
    { key: 'ESPECIALIDAD_CHIAPAS', label: 'Esp. Chiapas', color: '#065F46' },
    { key: 'ESPECIALIDAD_GUERRERO', label: 'Esp. Guerrero', color: '#9F1239' },
    { key: 'DESCAFEINADO', label: 'Descafeinado', color: '#92400E' },
    { key: 'CAFE_DE_OLLA', label: 'De Olla', color: '#D97706' },
    { key: 'CAFE_EJECUTIVO', label: 'Ejecutivo', color: '#1E3A8A' }
];

function AdminInventario() {
    const [clientGroups, setClientGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    
    const [selectedClient, setSelectedClient] = useState(null); 
    const [totalKilosMarket, setTotalKilosMarket] = useState(0);

    // --- MODAL DE AJUSTE (Tipo Almacén) ---
    const [showAdjustModal, setShowAdjustModal] = useState(false);
    const [adjustForm, setAdjustForm] = useState({
        sucursalId: '',
        producto: '',
        nombreSucursal: '',
        cantidad: '',
        tipo: 'MOLIDO',    // GRANO o MOLIDO
        accion: 'SUMAR'    // SUMAR (Ingreso) o RESTAR (Merma/Ajuste)
    });
    const [saving, setSaving] = useState(false);

    const fetchInventario = async () => {
        const token = localStorage.getItem('token');
        try {
            const { data } = await api.get('/sucursales/admin/all', { headers: { Authorization: `Bearer ${token}` } });
            
            const soloClientes = data.filter(suc => suc.usuario?.rol !== 'Admin');
            
            // Procesamiento corregido: Sumar Grano + Molido
            const datosProcesados = soloClientes.map(suc => {
                const sucursalPlana = { ...suc, stocks: {} };
                
                if (suc.inventarios && Array.isArray(suc.inventarios)) {
                    suc.inventarios.forEach(inv => {
                        // Guardamos el total (Grano + Molido) para la vista general
                        const total = (Number(inv.cantidadGrano) || 0) + (Number(inv.cantidadMolido) || 0);
                        sucursalPlana.stocks[inv.producto] = total;
                    });
                }
                return sucursalPlana;
            });

            agruparPorCliente(datosProcesados);

        } catch (error) {
            console.error("Error cargando inventario", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchInventario(); }, []);

    const agruparPorCliente = (sucursales) => {
        const groups = {};
        let grandTotal = 0;

        sucursales.forEach(suc => {
            const userId = suc.usuario?.id || 'unknown';
            const userName = suc.usuario?.perfil?.razonSocial || suc.usuario?.username || 'Sin Asignar';
            const userContact = suc.usuario?.email || '';

            if (!groups[userId]) {
                groups[userId] = {
                    id: userId,
                    name: userName,
                    contact: userContact,
                    branches: [],
                    totals: {} 
                };
                PRODUCTOS.forEach(p => groups[userId].totals[p.key] = 0);
            }

            groups[userId].branches.push(suc);

            PRODUCTOS.forEach(p => {
                const val = Number(suc.stocks[p.key] || 0);
                groups[userId].totals[p.key] += val;
                grandTotal += val;
            });
        });

        setTotalKilosMarket(grandTotal);
        setClientGroups(Object.values(groups));
    };

    // --- ABRIR MODAL DE AJUSTE ---
    const handleOpenAdjust = (sucursal, productoKey) => {
        setAdjustForm({
            sucursalId: sucursal.id,
            nombreSucursal: sucursal.nombre,
            producto: productoKey,
            cantidad: '',
            tipo: 'MOLIDO',
            accion: 'SUMAR'
        });
        setShowAdjustModal(true);
    };

    const handleSaveAdjust = async (e) => {
        e.preventDefault();
        setSaving(true);
        const token = localStorage.getItem('token');
        
        try {
            let cantidadFinal = Number(adjustForm.cantidad);
            if (adjustForm.accion === 'RESTAR') cantidadFinal *= -1;

            await api.post('/sucursales/stock/add', {
                sucursalId: adjustForm.sucursalId,
                producto: adjustForm.producto,
                cantidad: cantidadFinal,
                tipo: adjustForm.tipo
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            alert('✅ Stock actualizado');
            setShowAdjustModal(false);
            
            // Si estábamos viendo un detalle, lo cerramos para forzar recarga limpia
            setSelectedClient(null); 
            fetchInventario(); 

        } catch (error) {
            console.error(error);
            alert("Error al actualizar.");
        } finally {
            setSaving(false);
        }
    };

    const filteredGroups = clientGroups.filter(g => 
        g.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // --- ESTILOS ---
    const cardKpi = { background: THEME.white, padding: 20, borderRadius: 12, boxShadow: '0 4px 6px rgba(0,0,0,0.05)', flex: 1, borderLeft: `5px solid ${THEME.secondary}` };
    const tableHeader = { textAlign: 'center', padding: 12, borderBottom: `2px solid ${THEME.border}`, color: '#6B7280', fontSize: 11, textTransform: 'uppercase' };
    const tableCell = { padding: 12, borderBottom: `1px solid ${THEME.border}`, color: THEME.primary, fontSize: 13, textAlign: 'center', verticalAlign: 'middle' };
    const modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
    const modalContent = { background: 'white', borderRadius: 12, width: 900, maxWidth: '95%', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', overflow: 'hidden', maxHeight: '90vh', display:'flex', flexDirection:'column' };

    const stockBadge = (kilos, color) => ({
        fontWeight: 'bold',
        color: kilos > 0 ? color : '#E5E7EB',
        fontSize: kilos > 0 ? 13 : 12
    });

    if (loading) return <AdminLayout title="Inventario Global"><div style={{textAlign:'center', marginTop:50}}>Cargando...</div></AdminLayout>;

    return (
        <AdminLayout title="Inventario Global">
            
            <div style={{ display: 'flex', gap: 20, marginBottom: 30 }}>
                <div style={cardKpi}>
                    <div style={{ fontSize: 12, fontWeight: 'bold', color: '#6B7280', textTransform: 'uppercase' }}>Total Kilos en Mercado</div>
                    <div style={{ fontSize: 32, fontWeight: '900', color: THEME.primary }}>
                        {totalKilosMarket.toFixed(1)} <span style={{fontSize: 16}}>Kg</span>
                    </div>
                </div>
                
                <div style={{ ...cardKpi, borderLeft: `5px solid ${THEME.primary}`, display: 'flex', alignItems: 'center' }}>
                    <input 
                        type="text" 
                        placeholder="🔍 Buscar Cliente..." 
                        style={{ width: '100%', padding: 12, borderRadius: 8, border: `1px solid ${THEME.border}`, fontSize: 14 }}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div style={{ background: THEME.white, borderRadius: 12, boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 1000 }}>
                    <thead>
                        <tr>
                            <th style={{ ...tableHeader, textAlign: 'left' }}>Cliente (Dueño)</th>
                            <th style={tableHeader}>Tiendas</th>
                            {PRODUCTOS.map(f => (
                                <th key={f.key} style={{ ...tableHeader, color: f.color }}>Total {f.label}</th>
                            ))}
                            <th style={tableHeader}>Detalle</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredGroups.length === 0 ? (
                            <tr><td colSpan={PRODUCTOS.length + 3} style={{ padding: 30, textAlign: 'center', color: '#999' }}>No se encontraron clientes.</td></tr>
                        ) : (
                            filteredGroups.map(group => (
                                <tr key={group.id} style={{ background: 'white' }}>
                                    <td style={{ ...tableCell, textAlign: 'left' }}>
                                        <div style={{ fontWeight: 'bold' }}>{group.name}</div>
                                        <div style={{ fontSize: 11, color: '#9CA3AF' }}>{group.contact}</div>
                                    </td>
                                    <td style={tableCell}>
                                        <span style={{background: '#EFF6FF', color: THEME.secondary, padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight:'bold'}}>
                                            {group.branches.length}
                                        </span>
                                    </td>
                                    
                                    {PRODUCTOS.map(f => {
                                        const kilos = group.totals[f.key];
                                        return (
                                            <td key={f.key} style={tableCell}>
                                                <span style={stockBadge(kilos, f.color)}>
                                                    {kilos > 0 ? kilos.toFixed(1) : '-'}
                                                </span>
                                            </td>
                                        );
                                    })}

                                    <td style={tableCell}>
                                        <button 
                                            onClick={() => setSelectedClient(group)}
                                            style={{ background: THEME.bg, border: `1px solid ${THEME.border}`, padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 'bold' }}
                                        >
                                            Ver Sucursales →
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* MODAL DETALLE DE SUCURSALES */}
            {selectedClient && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <div style={{ padding: 20, background: THEME.primary, color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <h3 style={{ margin: 0, fontSize: 18 }}>Inventario por Sucursal</h3>
                                <div style={{ fontSize: 13, opacity: 0.8 }}>Cliente: {selectedClient.name}</div>
                            </div>
                            <button onClick={() => setSelectedClient(null)} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: 24, cursor: 'pointer' }}>×</button>
                        </div>

                        <div style={{ overflowY: 'auto', padding: 20 }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...tableHeader, textAlign: 'left' }}>Sucursal</th>
                                        {PRODUCTOS.map(f => (
                                            <th key={f.key} style={{...tableHeader, fontSize: 10, color: f.color}}>{f.label}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedClient.branches.map(suc => (
                                        <tr key={suc.id}>
                                            <td style={{ ...tableCell, textAlign: 'left' }}>
                                                <div style={{ fontWeight: 'bold' }}>{suc.nombre}</div>
                                                <div style={{ fontSize: 11, color: '#9CA3AF' }}>{suc.ciudad}</div>
                                            </td>
                                            {PRODUCTOS.map(f => {
                                                const kilos = suc.stocks[f.key] || 0;
                                                return (
                                                    <td key={f.key} style={tableCell}>
                                                        <div 
                                                            onClick={() => handleOpenAdjust(suc, f.key)}
                                                            style={{ 
                                                                cursor: 'pointer', 
                                                                fontWeight: kilos < 2 ? 'bold' : 'normal',
                                                                color: kilos < 2 && kilos > 0 ? THEME.danger : 'inherit',
                                                                border: '1px dashed transparent',
                                                                borderRadius: 4
                                                            }}
                                                            onMouseEnter={e => e.target.style.border = `1px dashed ${THEME.border}`}
                                                            onMouseLeave={e => e.target.style.border = '1px dashed transparent'}
                                                            title="Clic para ajustar"
                                                        >
                                                            {kilos.toFixed(1)}
                                                        </div>
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div style={{textAlign:'center', fontSize:11, color:'#999', marginTop:15}}>
                                * Haz clic sobre cualquier número para ajustar el stock (Grano/Molido).
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL DE AJUSTE RÁPIDO */}
            {showAdjustModal && (
                <div style={{...modalOverlay, zIndex: 1100}}>
                    <div style={{...modalContent, width: 400}}>
                        <div style={{padding: 25}}>
                            <h3 style={{marginTop:0, color: THEME.primary}}>Ajuste de Inventario</h3>
                            <p style={{fontSize:13, color: '#666', marginBottom:20}}>
                                {adjustForm.nombreSucursal} - <b>{PRODUCTOS.find(p=>p.key===adjustForm.producto)?.label}</b>
                            </p>

                            <form onSubmit={handleSaveAdjust}>
                                <div style={{display:'flex', gap:10, marginBottom:15}}>
                                    <button type="button" onClick={() => setAdjustForm({...adjustForm, accion: 'SUMAR'})} style={{flex:1, padding:8, border: adjustForm.accion === 'SUMAR' ? `2px solid ${THEME.success}` : '1px solid #ddd', borderRadius:6, background: adjustForm.accion === 'SUMAR' ? '#ECFDF5' : 'white', cursor:'pointer', fontWeight:'bold', color: adjustForm.accion === 'SUMAR' ? THEME.success : '#666'}}>📈 Ingreso</button>
                                    <button type="button" onClick={() => setAdjustForm({...adjustForm, accion: 'RESTAR'})} style={{flex:1, padding:8, border: adjustForm.accion === 'RESTAR' ? `2px solid ${THEME.danger}` : '1px solid #ddd', borderRadius:6, background: adjustForm.accion === 'RESTAR' ? '#FEF2F2' : 'white', cursor:'pointer', fontWeight:'bold', color: adjustForm.accion === 'RESTAR' ? THEME.danger : '#666'}}>📉 Corrección</button>
                                </div>

                                <label style={{display:'block', fontSize:12, fontWeight:'bold', marginBottom:5}}>Presentación</label>
                                <select style={{width:'100%', padding:10, marginBottom:15, borderRadius:6, border:'1px solid #ddd'}} value={adjustForm.tipo} onChange={e => setAdjustForm({...adjustForm, tipo: e.target.value})}>
                                    <option value="MOLIDO">⏳ Molido</option>
                                    <option value="GRANO">🫘 Grano</option>
                                </select>

                                <label style={{display:'block', fontSize:12, fontWeight:'bold', marginBottom:5}}>Cantidad (Kg)</label>
                                <input type="number" step="0.1" autoFocus required style={{width:'100%', padding:10, marginBottom:20, borderRadius:6, border:'1px solid #ddd', fontSize:18}} value={adjustForm.cantidad} onChange={e => setAdjustForm({...adjustForm, cantidad: e.target.value})} />

                                <div style={{display:'flex', gap:10}}>
                                    <button type="button" onClick={() => setShowAdjustModal(false)} style={{flex:1, padding:10, borderRadius:8, border:'none', background:'#f0f0f0', cursor:'pointer'}}>Cancelar</button>
                                    <button type="submit" disabled={saving} style={{flex:1, padding:10, borderRadius:8, border:'none', background:THEME.primary, color:'white', fontWeight:'bold', cursor:'pointer'}}>Confirmar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </AdminLayout>
    );
}

export default AdminInventario;